import { render } from "./landingView.vue?vue&type=template&id=56e6ee98"
import script from "./landingView.vue?vue&type=script&lang=js"
export * from "./landingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__